<template>
  <div id="historyDetail">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="body">
        <h4>'{{ this.$route.params.title  }}'의 상세 기록</h4>
        <div class="table-responsive">
          <table class="table" id="hitoryDetailTabl">
            <thead>
            <tr>
              <th>#</th>
              <th>&nbsp;</th>
              <th>실행 시작</th>
              <th>실행 종료</th>
              <th>종류</th>
              <th>결과</th>
              <th></th>
            </tr>
            </thead>
            <tbody v-for="(his, index) in list" :key="index">
            <tr>
              <th>{{ index + 1 }}</th>
              <th>
                <div>

                  <img
                    class="workIcon w60 rounded" alt="Rounded Image"
                    :src="imagePaths(his.appImage)"
                  />
                  <!--                  &nbsp;-->
                  <!--                  <i class="zmdi zmdi-forward"></i>-->
                  <!--                  <img-->
                  <!--                    class="workIcon w60 rounded" alt="Rounded Image"-->
                  <!--                    :src="imagePaths(his.endImage)"-->
                  <!--                  />-->
                </div>
              </th>
              <td>{{ his.startTime }}</td>
              <td>{{ his.stopTime }}</td>
              <td>
                {{ setApiType(index)}}
                <!--                <span v-if="apiHistorys[index].apiType == 'trigger'">-->
                <!--                  트리거-->
                <!--                </span>-->
                <!--                <span v-else>-->
                <!--                  액션-->
                <!--                </span>-->
              </td>
              <td>
                <span v-if="his.result == 'N'">
                  실패
                </span>
                <span v-else>
                  성공
                </span>
              </td>
              <td v-if="his.result == 'N'" @click="showResult(index)">
                <span class="badge badge-warning">결과보기</span>
              </td>
            </tr>
            <tr v-if="his.showResults">
              <td></td>
              <td colspan="5" id="historyResult">
                <textarea class="form-control" rows="5" v-html="resultDatas">
                </textarea>
              </td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>

        <div style="text-align: center;">
          <button type="button" class="btn btn-primary" v-if="skipNum > 0" @click="getPreviousPage">이전</button>
          <span v-for="num in Math.ceil(totalCount/pageNum)" :key="num">
              <button class="btn" v-if="num != skipNum + 1 && num < skipNum + 4 && num > skipNum - 4" @click="skipToPage(num)" style="color: forestgreen">{{ num }}</button>
              <button type="button" class="btn" v-if="num == skipNum + 1" @click="skipToPage(num)" style="color: #00dd3a">{{ num }}</button>
          </span>
          <button type="button" class="btn btn-primary " v-if="list.length == 20 && pageNum * skipNum + 20 < totalCount" @click="getNextPage">다음</button>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'HistoryDetailPage',
  components: {
  },
  data() {
    return {
      apiHistoryCode: "",
      list : [],
      resultDatas : "",

      pageNum : 20,
      skipNum: 0,
      totalCount: 0,
    }
  },
  methods: {
    skipToPage(num) {
      this.list = [];
      this.skipNum = num-1;

      this.getHistoryDetail();

    },
    getPreviousPage() {
      this.list = [];
      this.skipNum = this.skipNum - 1;

      this.getHistoryDetail();
    },
    getNextPage() {
      this.list = [];
      this.skipNum = this.skipNum + 1;

      this.getHistoryDetail();

    },
    showResult(index) {
      console.log("클릭함", index)

      for(var i = 0; i < this.list.length; i++){
        if(i == index){
          this.list[i].showResults = !this.list[i].showResults

        } else {

          this.list[i].showResults = false
        }
      }

      console.log(typeof this.list[index].resultData, this.list[index].resultData)

      if(typeof this.list[index].resultData ==='object'){
        this.resultDatas = JSON.stringify(JSON.parse(this.list[index].resultData), null, 4);

      } else {
        this.resultDatas = this.list[index].resultData;
      }



    },
    imagePaths(value) {
      if (value != null && value != "") {
        return (
          "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" +
          value
        );
      } else {
        return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg";
      }
    },
    setApiType(index){
      var check = this.list[index]

      if(check.result == "Y"){

        if(JSON.parse(check.sentData).apiType == "trigger"){
          return "트리거"
        } else {
          return "액션"
        }
      } else {
        return "-"
      }



    },
    getHistoryDetail() {
      var param = {
        workflowCode: this.$store.state.workflowStore.workflowCode,
        pageNum : this.pageNum,
        skipNum : this.skipNum
      };
      this.api.getWorkflowHistoryDetail(param).then((res) => {
        console.log("getWorkflowHistoryDetail res : ", res);

        if (this.utils.preApiHandle(res)) {

          console.log("dev front page res : ", res);

          this.totalCount = res.totalCount;

        }

        if (res["code"] == 0) {

          var llist = [];


          for (var i = 0; i < res.list.length; i++) {
            var obj = {
              apiCode: res.list[i].apiCode,
              appCode: res.list[i].appCode,
              historyCode: res.list[i].historyCode,
              result: res.list[i].result,
              resultData: res.list[i].resultData,
              sentData: res.list[i].sentData,
              startTime: res.list[i].startTime,
              stopTime: res.list[i].stopTime,
              showResults: false

            };
            llist.push(obj);

          }


          this.list = llist;


        }
      });
    }
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
    workflowDetailHistorys() {
      return this.$store.state.workflowStore.workflowDetailHistorys;
    },
    apiHistorys() {
      return this.$store.state.workflowStore.apiHistorys;
    }
  },
  created() {
    console.log('HistoryDetailPage created')
    this.getHistoryDetail();
  },
  mounted() {
    console.log('HistoryDetailPage created')
  },
  beforeDestroy() {
    console.log('HistoryDetailPage beforeDestroy')
  }
}
</script>
<style scoped>
#historyDetail {
  padding: 10px;
}

#hitoryDetailTabl {
  text-align: center;
}
#historyResult {
  width: 500px;
}
</style>
